"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line: completed-docs
/**
 * Expression parser error listener.
 */
class ParseErrorListener {
    syntaxError(_recognizer, _offendingSymbol, line, charPositionInLine, msg, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _e) {
        throw Error(`syntax error at line ${line}:${charPositionInLine} ${msg}`);
    }
}
ParseErrorListener.Instance = new ParseErrorListener();
exports.ParseErrorListener = ParseErrorListener;
//# sourceMappingURL=parseErrorListener.js.map